import React, { useState } from "react";
import { Grid, FormHelperText } from "@material-ui/core";
import FormatIndentIncreaseIcon from "@material-ui/icons/FormatIndentIncrease";
import { useFormikContext } from "formik";
import { convertToRaw } from "draft-js";
import MUIRichTextEditor from "mui-rte";
import { CertificateTypeData } from "../../../../../../models/certificateTypeData";
import { CertificateTypesDropDown } from "./CertificateTypesDropDown";
import CustomCheckbox from "../../../../../forms/CustomCheckbox";
import { ELearningFormData } from "../../../../../../models/elearning";
import { EventFormData } from "../../../../../../models/eventData";
import { EventStatus } from "../../../../../../models/enums/eventStatus.enum";
import { useStyles } from "../../../shared/content/Content.styles";
interface CertificateTypeProps {
  allCertificateTypes: CertificateTypeData[];
  eventCertificateType: CertificateTypeData;
  isEventCertificationActivated: boolean;
}

export const CertificateTypes: React.FC<CertificateTypeProps> = ({
  allCertificateTypes,
  eventCertificateType,
  isEventCertificationActivated,
}) => {
  const classes = useStyles();
  const [isCertificationActivated, setIsCertificationActivated] = useState(
    isEventCertificationActivated
  );

  const { values, setFieldValue, errors, isValid, submitCount, dirty } =
    useFormikContext<EventFormData | ELearningFormData>();

  /**
   * Determines if validation error for description should be displayed.
   */
  function checkValidation() {
    return errors.description && !isValid && submitCount > 0 && dirty;
  }

  return (
    <div style={{ padding: ".625rem 0 .625rem 0" }}>
      <Grid item lg={12} xs={6} sm={3} style={{ padding: ".625rem 0 .625rem 0" }}>
        <CustomCheckbox
          name="certtificateActivated"
          label={<>Zertifizierung</>}
          checked={isCertificationActivated}
          onChange={() => {
            setIsCertificationActivated(!isCertificationActivated);
            setFieldValue("is_certification_selected", !isCertificationActivated);
          }}
        />
      </Grid>
      {isCertificationActivated ? (
        <CertificateTypesDropDown
          allCertificateTypes={allCertificateTypes}
          eventCertificateType={eventCertificateType}
        />
      ) : null}

      <Grid item xs={12}>
        <h3>Zertifikatsinhalte spezifizieren</h3>

        <MUIRichTextEditor
          onChange={(changedVal) => {
            setFieldValue("training_content", changedVal.getCurrentContent());
          }}
          readOnly={values.status === EventStatus.Completed}
          defaultValue={JSON.stringify(convertToRaw(values.trainingContentState))}
          label="Beschreiben Sie die Zertifikatsinhalte"
          classes={{
            root: checkValidation() ? classes.errorRoot : undefined,
            editor: checkValidation() ? classes.error : undefined,
          }}
          controls={[
            "title",
            "underline",
            "undo",
            "redo",
            "numberList",
            "bulletList",
            "indentLine",
            "link",
          ]}
          customControls={[
            {
              name: "indentLine",
              icon: <FormatIndentIncreaseIcon />,
              type: "inline",
              inlineStyle: {
                marginLeft: "1.25rem",
              },
            },
          ]}
          draftEditorProps={{
            spellCheck: true,
            stripPastedStyles: true,
          }}
        />
        {checkValidation() && (
          <FormHelperText variant="filled" error={checkValidation()}>
            {errors.description}
          </FormHelperText>
        )}
      </Grid>
    </div>
  );
};
